export const SocketSignalReducer = (state, action) => {
  switch (action.type) {
    case 'changeTestStatus':
      return { ...state, testStatus: !state.testStatus };
    default:
      return state;
  }
};
